// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shift Summary Section Styles */
.shift-summary-section {
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.shift-details-header {
  background-color: #f8f9fa !important;
  border: 1px solid #dee2e6;
}

.shift-details-header .row > div {
  margin-bottom: 0.5rem;
}

.shift-details-header strong {
  color: #495057;
  font-size: 0.875rem;
}

.shift-value {
  font-weight: 500;
  color: #212529;
}

.financial-summary table {
  font-size: 0.9rem;
}

.financial-summary th {
  background-color: #f8f9fa !important;
  font-weight: 600;
  text-align: center;
}

.financial-summary td {
  vertical-align: middle;
}

.closing-details {
  background-color: #f8f9fa !important;
  border: 1px solid #dee2e6;
}

.closing-details .row > div {
  margin-bottom: 0.5rem;
}

.closing-details strong {
  color: #495057;
  font-size: 0.875rem;
}

.reconciliation-item {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reconciliation-item .label {
  font-weight: 500;
  color: #495057;
  margin-right: 10px;
}

.reconciliation-item .value {
  font-weight: 600;
  color: #212529;
}

.notes-content {
  min-height: 60px;
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  color: #495057;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Print Styles */
@media print {
  /* Hide non-printable elements */
  .btn {
    display: none !important;
  }
  /* Hide screen header in print mode */
  .d-flex.justify-content-between {
    display: none !important;
  }
  /* Aggressively hide ALL non-printable elements and ensure they take NO space */
  .btn,
  button,
  .d-flex.justify-content-between,
  .d-flex.justify-content-center,
  .d-print-none,
  .no-print,
  .hidden-print,
  [style*="display: none"],
  [style*="display:none"] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    height: 0 !important;
    width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    left: -9999px !important;
    top: -9999px !important;
    z-index: -9999 !important;
    pointer-events: none !important;
  }
  /* Ensure hidden elements take absolutely no space */
  .d-none,
  .d-print-none,
  .hidden,
  .invisible {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    left: -9999px !important;
    top: -9999px !important;
    z-index: -9999 !important;
    pointer-events: none !important;
  }
  /* Reset body and html margins for print */
  body, html {
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
  }
  /* Set page margins */
  @page {
    margin: 0 !important;
    padding: 0 !important;
    size: auto !important;
  }
  /* Main printable container */
  .printable-container {
    margin: 0 !important;
    padding: 10mm !important; /* Internal padding so it doesn't touch edges */
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    overflow: visible !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    box-sizing: border-box !important;
    transform: none !important;
  }
  /* Shift summary section */
  .shift-summary-section {
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    transform: none !important;
    text-align: left !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    box-sizing: border-box !important;
  }
  /* Override any potential top margins from Bootstrap or other frameworks */
  .printable-container *,
  .shift-summary-section * {
    margin-top: 0 !important;
    padding-top: 0 !important;
    text-align: left !important;
  }
  /* Ensure the first element has no top margin and starts at the top */
  .printable-container > *:first-child,
  .shift-summary-section > *:first-child {
    margin-top: 0 !important;
    padding-top: 0 !important;
    position: relative !important;
    top: 0 !important;
  }
  /* Force content to start at the very top */
  .shift-summary-section::before {
    content: none !important;
  }
  /* Override any Bootstrap centering classes in print - but keep titles centered */
  .text-center {
    text-align: center !important;
  }
  .justify-content-center {
    justify-content: center !important;
  }
  .justify-content-between {
    justify-content: flex-start !important;
  }
  /* Print Header - Ensure it starts at the very top with NO margins */
  .print-header {
    margin: 0 !important;
    padding: 0 !important;
    text-align: center !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    display: block !important;
    line-height: 1 !important;
  }
  .print-header h2 {
    margin: 0 0 8px 0 !important;
    padding: 0 !important;
    text-align: center !important;
    font-size: 14pt !important;
    font-weight: bold !important;
    color: #000 !important;
    line-height: 1.2 !important;
  }
  .print-header p {
    margin: 0 0 15px 0 !important;
    padding: 0 !important;
    text-align: center !important;
    font-size: 10pt !important;
    color: #000 !important;
    line-height: 1.2 !important;
  }
  /* Remove any potential spacing from the first element */
  .printable-container > .print-header:first-child {
    margin-top: 0 !important;
    padding-top: 0 !important;
    top: 0 !important;
  }
  /* Ensure no margins on the container itself */
  .printable-container {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  /* Override Bootstrap margin classes in print */
  .m-4 {
    margin: 0 !important;
  }
  .p-4 {
    padding: 0 !important;
  }
  .mb-4 {
    margin-bottom: 15px !important;
  }
  /* Force content to start at the very top of the page */
  .printable-container,
  .shift-summary-section,
  .print-header {
    margin-top: 0 !important;
    padding-top: 0 !important;
    top: 0 !important;
  }
  /* Remove any potential spacing from the body or html */
  body, html {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  /* Ensure ONLY the print header is visible and positioned at the very top */
  .print-header {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    height: auto !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    z-index: 1 !important;
    pointer-events: auto !important;
  }
  /* Hide ALL other elements that might interfere with positioning */
  .printable-container > *:not(.print-header) {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  /* Force the first visible element to be the print header */
  .printable-container > .print-header:first-child {
    margin-top: 0 !important;
    padding-top: 0 !important;
    top: 0 !important;
    position: relative !important;
  }
  /* Ensure no other elements create space before the print header */
  .printable-container::before,
  .printable-container::after,
  .shift-summary-section::before,
  .shift-summary-section::after {
    content: none !important;
    display: none !important;
    height: 0 !important;
    width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  /* Shift Details Header */
  .shift-details-header {
    background: #fff !important;
    border: 1px solid #000 !important;
    padding: 12px !important;
    margin: 0 0 15px 0 !important;
    border-radius: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    text-align: left !important;
  }
  .shift-details-header .row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .shift-details-header .col-md-3 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
    padding: 6px !important;
    margin-bottom: 8px !important;
    box-sizing: border-box !important;
  }
  .shift-details-header strong {
    display: block !important;
    font-weight: bold !important;
    font-size: 9pt !important;
    margin-bottom: 3px !important;
    color: #000 !important;
  }
  .shift-details-header div {
    font-size: 9pt !important;
    color: #000 !important;
  }
  .shift-value {
    font-weight: 500 !important;
    color: #000 !important;
    font-size: 9pt !important;
  }
  .badge {
    display: inline-block !important;
    padding: 3px 6px !important;
    border: 1px solid #000 !important;
    background: #f0f0f0 !important;
    color: #000 !important;
    border-radius: 10px !important;
    font-size: 8pt !important;
  }
  /* Financial Summary Table */
  .financial-summary {
    margin: 0 0 15px 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  .financial-summary h5 {
    font-size: 12pt !important;
    font-weight: bold !important;
    margin: 0 0 8px 0 !important;
    color: #000 !important;
    text-align: center !important;
    border-bottom: 1px solid #000 !important;
    padding-bottom: 5px !important;
  }
  .financial-summary table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin: 0 !important;
    border: 2px solid #000 !important;
    table-layout: fixed !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  .financial-summary th {
    background: #f0f0f0 !important;
    border: 1px solid #000 !important;
    padding: 6px 4px !important;
    text-align: center !important;
    font-weight: bold !important;
    font-size: 8pt !important;
    color: #000 !important;
  }
  .financial-summary td {
    border: 1px solid #000 !important;
    padding: 4px 4px !important;
    text-align: center !important;
    font-size: 8pt !important;
    color: #000 !important;
    vertical-align: middle !important;
  }
  .financial-summary td:first-child {
    text-align: right !important;
    font-weight: bold !important;
  }
  /* Closing Details */
  .closing-details {
    background: #fff !important;
    border: 1px solid #000 !important;
    padding: 12px !important;
    border-radius: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  .closing-details h6 {
    font-size: 11pt !important;
    font-weight: bold !important;
    margin: 0 0 8px 0 !important;
    color: #000 !important;
    text-align: center !important;
    border-bottom: 1px solid #000 !important;
    padding-bottom: 5px !important;
  }
  .closing-details .row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .closing-details .col-md-4 {
    flex: 0 0 33.333% !important;
    max-width: 33.333% !important;
    padding: 6px !important;
    margin-bottom: 8px !important;
    box-sizing: border-box !important;
    border-right: 1px solid #000 !important;
  }
  .closing-details .col-md-4:last-child {
    border-right: none !important;
  }
  .closing-details strong {
    display: block !important;
    font-weight: bold !important;
    font-size: 9pt !important;
    margin-bottom: 5px !important;
    color: #000 !important;
  }
  .reconciliation-item {
    margin-bottom: 6px !important;
    font-size: 8pt !important;
  }
  .reconciliation-item .label {
    font-weight: 500 !important;
    color: #000 !important;
  }
  .reconciliation-item .value {
    font-weight: 600 !important;
    color: #000 !important;
  }
  .notes-content {
    min-height: 40px !important;
    padding: 6px !important;
    background: #fff !important;
    border: 1px solid #000 !important;
    color: #000 !important;
    font-size: 8pt !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/shift-summary-display/shift-summary-display.component.scss"],"names":[],"mappings":"AAAA,iCAAA;AACA;EACI,yBAAA;EACA,wCAAA;AACJ;;AAEA;EACI,oCAAA;EACA,yBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,yBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;AACJ;;AAEA,iBAAA;AACA;EACI,gCAAA;EACA;IACI,wBAAA;EACN;EAEE,qCAAA;EACA;IACI,wBAAA;EAAN;EAGE,+EAAA;EACA;;;;;;;;;IASI,wBAAA;IACA,6BAAA;IACA,qBAAA;IACA,oBAAA;IACA,mBAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,uBAAA;IACA,yBAAA;IACA,+BAAA;EADN;EAIE,oDAAA;EACA;;;;IAII,wBAAA;IACA,6BAAA;IACA,oBAAA;IACA,mBAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,uBAAA;IACA,yBAAA;IACA,+BAAA;EAFN;EAKE,0CAAA;EACA;IACI,oBAAA;IACA,qBAAA;IACA,uBAAA;EAHN;EAME,qBAAA;EACA;IACI,oBAAA;IACA,qBAAA;IACA,qBAAA;EAJN;EAOE,6BAAA;EACA;IACI,oBAAA;IACA,wBAAA,EAAA,+CAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,mCAAA;IACA,8BAAA;IACA,6BAAA;IACA,iBAAA;IACA,kBAAA;IACA,iCAAA;IACA,0BAAA;EALN;EAQE,0BAAA;EACA;IACI,2BAAA;IACA,uBAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,mCAAA;IACA,8BAAA;IACA,6BAAA;IACA,iBAAA;IACA,kBAAA;IACA,wBAAA;IACA,yBAAA;IACA,0BAAA;IACA,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,iCAAA;EANN;EASE,0EAAA;EACA;;IAEI,wBAAA;IACA,yBAAA;IACA,2BAAA;EAPN;EAUE,qEAAA;EACA;;IAEI,wBAAA;IACA,yBAAA;IACA,6BAAA;IACA,iBAAA;EARN;EAWE,2CAAA;EACA;IACI,wBAAA;EATN;EAYE,iFAAA;EACA;IACI,6BAAA;EAVN;EAaE;IACI,kCAAA;EAXN;EAcE;IACI,sCAAA;EAZN;EAeE,oEAAA;EACA;IACI,oBAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;IACA,iBAAA;IACA,kBAAA;IACA,yBAAA;IACA,yBAAA;EAbN;EAgBE;IACI,4BAAA;IACA,qBAAA;IACA,6BAAA;IACA,0BAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;EAdN;EAiBE;IACI,6BAAA;IACA,qBAAA;IACA,6BAAA;IACA,0BAAA;IACA,sBAAA;IACA,2BAAA;EAfN;EAkBE,wDAAA;EACA;IACI,wBAAA;IACA,yBAAA;IACA,iBAAA;EAhBN;EAmBE,8CAAA;EACA;IACI,wBAAA;IACA,yBAAA;EAjBN;EAoBE,+CAAA;EACA;IACI,oBAAA;EAlBN;EAqBE;IACI,qBAAA;EAnBN;EAsBE;IACI,8BAAA;EApBN;EAuBE,uDAAA;EACA;;;IAGI,wBAAA;IACA,yBAAA;IACA,iBAAA;EArBN;EAwBE,uDAAA;EACA;IACI,wBAAA;IACA,yBAAA;EAtBN;EAyBE,2EAAA;EACA;IACI,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,uBAAA;IACA,sBAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;IACA,qBAAA;IACA,+BAAA;EAvBN;EA0BE,kEAAA;EACA;IACI,wBAAA;IACA,yBAAA;EAxBN;EA2BE,2DAAA;EACA;IACI,wBAAA;IACA,yBAAA;IACA,iBAAA;IACA,6BAAA;EAzBN;EA4BE,kEAAA;EACA;;;;IAII,wBAAA;IACA,wBAAA;IACA,oBAAA;IACA,mBAAA;IACA,oBAAA;IACA,qBAAA;EA1BN;EA6BE,yBAAA;EACA;IACI,2BAAA;IACA,iCAAA;IACA,wBAAA;IACA,6BAAA;IACA,2BAAA;IACA,mCAAA;IACA,8BAAA;IACA,2BAAA;EA3BN;EA8BE;IACI,wBAAA;IACA,0BAAA;IACA,oBAAA;IACA,sBAAA;EA5BN;EA+BE;IACI,wBAAA;IACA,yBAAA;IACA,uBAAA;IACA,6BAAA;IACA,iCAAA;EA7BN;EAgCE;IACI,yBAAA;IACA,4BAAA;IACA,yBAAA;IACA,6BAAA;IACA,sBAAA;EA9BN;EAiCE;IACI,yBAAA;IACA,sBAAA;EA/BN;EAkCE;IACI,2BAAA;IACA,sBAAA;IACA,yBAAA;EAhCN;EAmCE;IACI,gCAAA;IACA,2BAAA;IACA,iCAAA;IACA,8BAAA;IACA,sBAAA;IACA,8BAAA;IACA,yBAAA;EAjCN;EAoCE,4BAAA;EACA;IACI,6BAAA;IACA,mCAAA;IACA,8BAAA;EAlCN;EAqCE;IACI,0BAAA;IACA,4BAAA;IACA,4BAAA;IACA,sBAAA;IACA,6BAAA;IACA,wCAAA;IACA,8BAAA;EAnCN;EAsCE;IACI,sBAAA;IACA,oCAAA;IACA,oBAAA;IACA,iCAAA;IACA,8BAAA;IACA,mCAAA;IACA,8BAAA;EApCN;EAuCE;IACI,8BAAA;IACA,iCAAA;IACA,2BAAA;IACA,6BAAA;IACA,4BAAA;IACA,yBAAA;IACA,sBAAA;EArCN;EAwCE;IACI,iCAAA;IACA,2BAAA;IACA,6BAAA;IACA,yBAAA;IACA,sBAAA;IACA,iCAAA;EAtCN;EAyCE;IACI,4BAAA;IACA,4BAAA;EAvCN;EA0CE,oBAAA;EACA;IACI,2BAAA;IACA,iCAAA;IACA,wBAAA;IACA,2BAAA;IACA,mCAAA;IACA,8BAAA;EAxCN;EA2CE;IACI,0BAAA;IACA,4BAAA;IACA,4BAAA;IACA,sBAAA;IACA,6BAAA;IACA,wCAAA;IACA,8BAAA;EAzCN;EA4CE;IACI,wBAAA;IACA,0BAAA;IACA,oBAAA;IACA,sBAAA;EA1CN;EA6CE;IACI,4BAAA;IACA,6BAAA;IACA,uBAAA;IACA,6BAAA;IACA,iCAAA;IACA,uCAAA;EA3CN;EA8CE;IACI,6BAAA;EA5CN;EA+CE;IACI,yBAAA;IACA,4BAAA;IACA,yBAAA;IACA,6BAAA;IACA,sBAAA;EA7CN;EAgDE;IACI,6BAAA;IACA,yBAAA;EA9CN;EAiDE;IACI,2BAAA;IACA,sBAAA;EA/CN;EAkDE;IACI,2BAAA;IACA,sBAAA;EAhDN;EAmDE;IACI,2BAAA;IACA,uBAAA;IACA,2BAAA;IACA,iCAAA;IACA,sBAAA;IACA,yBAAA;EAjDN;AACF","sourcesContent":["/* Shift Summary Section Styles */\n.shift-summary-section {\n    background-color: #ffffff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.shift-details-header {\n    background-color: #f8f9fa !important;\n    border: 1px solid #dee2e6;\n}\n\n.shift-details-header .row > div {\n    margin-bottom: 0.5rem;\n}\n\n.shift-details-header strong {\n    color: #495057;\n    font-size: 0.875rem;\n}\n\n.shift-value {\n    font-weight: 500;\n    color: #212529;\n}\n\n.financial-summary table {\n    font-size: 0.9rem;\n}\n\n.financial-summary th {\n    background-color: #f8f9fa !important;\n    font-weight: 600;\n    text-align: center;\n}\n\n.financial-summary td {\n    vertical-align: middle;\n}\n\n.closing-details {\n    background-color: #f8f9fa !important;\n    border: 1px solid #dee2e6;\n}\n\n.closing-details .row > div {\n    margin-bottom: 0.5rem;\n}\n\n.closing-details strong {\n    color: #495057;\n    font-size: 0.875rem;\n}\n\n.reconciliation-item {\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.reconciliation-item .label {\n    font-weight: 500;\n    color: #495057;\n    margin-right: 10px;\n}\n\n.reconciliation-item .value {\n    font-weight: 600;\n    color: #212529;\n}\n\n.notes-content {\n    min-height: 60px;\n    padding: 8px;\n    background-color: #ffffff;\n    border: 1px solid #dee2e6;\n    border-radius: 0.25rem;\n    color: #495057;\n}\n\n.badge {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n}\n\n/* Print Styles */\n@media print {\n    /* Hide non-printable elements */\n    .btn {\n        display: none !important;\n    }\n    \n    /* Hide screen header in print mode */\n    .d-flex.justify-content-between {\n        display: none !important;\n    }\n    \n    /* Aggressively hide ALL non-printable elements and ensure they take NO space */\n    .btn,\n    button,\n    .d-flex.justify-content-between,\n    .d-flex.justify-content-center,\n    .d-print-none,\n    .no-print,\n    .hidden-print,\n    [style*=\"display: none\"],\n    [style*=\"display:none\"] {\n        display: none !important;\n        visibility: hidden !important;\n        opacity: 0 !important;\n        height: 0 !important;\n        width: 0 !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: hidden !important;\n        position: absolute !important;\n        left: -9999px !important;\n        top: -9999px !important;\n        z-index: -9999 !important;\n        pointer-events: none !important;\n    }\n    \n    /* Ensure hidden elements take absolutely no space */\n    .d-none,\n    .d-print-none,\n    .hidden,\n    .invisible {\n        display: none !important;\n        visibility: hidden !important;\n        height: 0 !important;\n        width: 0 !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: hidden !important;\n        position: absolute !important;\n        left: -9999px !important;\n        top: -9999px !important;\n        z-index: -9999 !important;\n        pointer-events: none !important;\n    }\n    \n    /* Reset body and html margins for print */\n    body, html {\n        margin: 0 !important;\n        padding: 0 !important;\n        height: auto !important;\n    }\n    \n    /* Set page margins */\n    @page {\n        margin: 0 !important;\n        padding: 0 !important;\n        size: auto !important;\n    }\n    \n    /* Main printable container */\n    .printable-container {\n        margin: 0 !important;\n        padding: 10mm !important; /* Internal padding so it doesn't touch edges */\n        width: 100% !important; \n        max-width: 100% !important;\n        height: auto !important;\n        min-height: auto !important;\n        overflow: visible !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n        position: relative !important;\n        top: 0 !important;\n        left: 0 !important;\n        box-sizing: border-box !important;\n        transform: none !important;\n    }\n    \n    /* Shift summary section */\n    .shift-summary-section {\n        box-shadow: none !important;\n        border: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        background: #fff !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n        position: relative !important;\n        top: 0 !important;\n        left: 0 !important;\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        transform: none !important;\n        text-align: left !important;\n        width: 100% !important; \n        max-width: 100% !important;\n        height: auto !important;\n        min-height: auto !important;\n        box-sizing: border-box !important;\n    }\n    \n    /* Override any potential top margins from Bootstrap or other frameworks */\n    .printable-container *,\n    .shift-summary-section * {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        text-align: left !important;\n    }\n    \n    /* Ensure the first element has no top margin and starts at the top */\n    .printable-container > *:first-child,\n    .shift-summary-section > *:first-child {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        position: relative !important;\n        top: 0 !important;\n    }\n    \n    /* Force content to start at the very top */\n    .shift-summary-section::before {\n        content: none !important;\n    }\n    \n    /* Override any Bootstrap centering classes in print - but keep titles centered */\n    .text-center {\n        text-align: center !important;\n    }\n    \n    .justify-content-center {\n        justify-content: center !important;\n    }\n    \n    .justify-content-between {\n        justify-content: flex-start !important;\n    }\n    \n    /* Print Header - Ensure it starts at the very top with NO margins */\n    .print-header {\n        margin: 0 !important;\n        padding: 0 !important;\n        text-align: center !important;\n        position: relative !important;\n        top: 0 !important;\n        left: 0 !important;\n        display: block !important;\n        line-height: 1 !important;\n    }\n    \n    .print-header h2 {\n        margin: 0 0 8px 0 !important;\n        padding: 0 !important;\n        text-align: center !important;\n        font-size: 14pt !important;\n        font-weight: bold !important;\n        color: #000 !important;\n        line-height: 1.2 !important;\n    }\n    \n    .print-header p {\n        margin: 0 0 15px 0 !important;\n        padding: 0 !important;\n        text-align: center !important;\n        font-size: 10pt !important;\n        color: #000 !important;\n        line-height: 1.2 !important;\n    }\n    \n    /* Remove any potential spacing from the first element */\n    .printable-container > .print-header:first-child {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        top: 0 !important;\n    }\n    \n    /* Ensure no margins on the container itself */\n    .printable-container {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n    }\n    \n    /* Override Bootstrap margin classes in print */\n    .m-4 {\n        margin: 0 !important;\n    }\n    \n    .p-4 {\n        padding: 0 !important;\n    }\n    \n    .mb-4 {\n        margin-bottom: 15px !important;\n    }\n    \n    /* Force content to start at the very top of the page */\n    .printable-container,\n    .shift-summary-section,\n    .print-header {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        top: 0 !important;\n    }\n    \n    /* Remove any potential spacing from the body or html */\n    body, html {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n    }\n    \n    /* Ensure ONLY the print header is visible and positioned at the very top */\n    .print-header {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        height: auto !important;\n        width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible !important;\n        position: relative !important;\n        left: 0 !important;\n        top: 0 !important;\n        z-index: 1 !important;\n        pointer-events: auto !important;\n    }\n    \n    /* Hide ALL other elements that might interfere with positioning */\n    .printable-container > *:not(.print-header) {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n    }\n    \n    /* Force the first visible element to be the print header */\n    .printable-container > .print-header:first-child {\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        top: 0 !important;\n        position: relative !important;\n    }\n    \n    /* Ensure no other elements create space before the print header */\n    .printable-container::before,\n    .printable-container::after,\n    .shift-summary-section::before,\n    .shift-summary-section::after {\n        content: none !important;\n        display: none !important;\n        height: 0 !important;\n        width: 0 !important;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n    \n    /* Shift Details Header */\n    .shift-details-header {\n        background: #fff !important;\n        border: 1px solid #000 !important;\n        padding: 12px !important;\n        margin: 0 0 15px 0 !important;\n        border-radius: 0 !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n        text-align: left !important;\n    }\n    \n    .shift-details-header .row {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        margin: 0 !important;\n        width: 100% !important;\n    }\n    \n    .shift-details-header .col-md-3 {\n        flex: 0 0 50% !important;\n        max-width: 50% !important;\n        padding: 6px !important;\n        margin-bottom: 8px !important;\n        box-sizing: border-box !important;\n    }\n    \n    .shift-details-header strong {\n        display: block !important;\n        font-weight: bold !important;\n        font-size: 9pt !important;\n        margin-bottom: 3px !important;\n        color: #000 !important;\n    }\n    \n    .shift-details-header div {\n        font-size: 9pt !important;\n        color: #000 !important;\n    }\n    \n    .shift-value {\n        font-weight: 500 !important;\n        color: #000 !important;\n        font-size: 9pt !important;\n    }\n    \n    .badge {\n        display: inline-block !important;\n        padding: 3px 6px !important;\n        border: 1px solid #000 !important;\n        background: #f0f0f0 !important;\n        color: #000 !important;\n        border-radius: 10px !important;\n        font-size: 8pt !important;\n    }\n    \n    /* Financial Summary Table */\n    .financial-summary {\n        margin: 0 0 15px 0 !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n    }\n    \n    .financial-summary h5 {\n        font-size: 12pt !important;\n        font-weight: bold !important;\n        margin: 0 0 8px 0 !important;\n        color: #000 !important;\n        text-align: center !important;\n        border-bottom: 1px solid #000 !important;\n        padding-bottom: 5px !important;\n    }\n    \n    .financial-summary table {\n        width: 100% !important;\n        border-collapse: collapse !important;\n        margin: 0 !important;\n        border: 2px solid #000 !important;\n        table-layout: fixed !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n    }\n    \n    .financial-summary th {\n        background: #f0f0f0 !important;\n        border: 1px solid #000 !important;\n        padding: 6px 4px !important;\n        text-align: center !important;\n        font-weight: bold !important;\n        font-size: 8pt !important;\n        color: #000 !important;\n    }\n    \n    .financial-summary td {\n        border: 1px solid #000 !important;\n        padding: 4px 4px !important;\n        text-align: center !important;\n        font-size: 8pt !important;\n        color: #000 !important;\n        vertical-align: middle !important;\n    }\n    \n    .financial-summary td:first-child {\n        text-align: right !important;\n        font-weight: bold !important;\n    }\n    \n    /* Closing Details */\n    .closing-details {\n        background: #fff !important;\n        border: 1px solid #000 !important;\n        padding: 12px !important;\n        border-radius: 0 !important;\n        page-break-inside: avoid !important;\n        break-inside: avoid !important;\n    }\n    \n    .closing-details h6 {\n        font-size: 11pt !important;\n        font-weight: bold !important;\n        margin: 0 0 8px 0 !important;\n        color: #000 !important;\n        text-align: center !important;\n        border-bottom: 1px solid #000 !important;\n        padding-bottom: 5px !important;\n    }\n    \n    .closing-details .row {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        margin: 0 !important;\n        width: 100% !important;\n    }\n    \n    .closing-details .col-md-4 {\n        flex: 0 0 33.333% !important;\n        max-width: 33.333% !important;\n        padding: 6px !important;\n        margin-bottom: 8px !important;\n        box-sizing: border-box !important;\n        border-right: 1px solid #000 !important;\n    }\n    \n    .closing-details .col-md-4:last-child {\n        border-right: none !important;\n    }\n    \n    .closing-details strong {\n        display: block !important;\n        font-weight: bold !important;\n        font-size: 9pt !important;\n        margin-bottom: 5px !important;\n        color: #000 !important;\n    }\n    \n    .reconciliation-item {\n        margin-bottom: 6px !important;\n        font-size: 8pt !important;\n    }\n    \n    .reconciliation-item .label {\n        font-weight: 500 !important;\n        color: #000 !important;\n    }\n    \n    .reconciliation-item .value {\n        font-weight: 600 !important;\n        color: #000 !important;\n    }\n    \n    .notes-content {\n        min-height: 40px !important;\n        padding: 6px !important;\n        background: #fff !important;\n        border: 1px solid #000 !important;\n        color: #000 !important;\n        font-size: 8pt !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
